/* GriffinLayout.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3SamIHVa5s%7Bmargin-block%3Avar(--ds-space-400%2C2pc)%7D%0A._2Y7lL45zaO%7Bpadding-inline%3Avar(--ds-space-200%2C1pc)%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._2xTnZxIZbP%7Bmargin-inline-end%3Aauto%7D%0A._0GTcwRIZbP%7Bmargin-inline-start%3Aauto%7D%0A._24h04iPvdi%7Bbox-sizing%3Acontent-box%7D%0A._1EqgXlprl1%7Bmax-width%3A77pc%7D%0A%40media%20(min-width%3A64rem)%7B._1DVCh3Va5s%7Bpadding-inline%3Avar(--ds-space-400%2C2pc)%7D%7D%0A._3CkH9o19eh%7Bbackground-image%3Alinear-gradient(90deg%2C%2388888f0d%201px%2Ctransparent%200)%2Clinear-gradient(180deg%2C%2388888f0d%201px%2Ctransparent%200)%7D%0A._3OqcjTkyAR%7Bbackground-size%3A24px%2024px%7D%0A._2z4m57XEN5%7Bbackground-repeat%3Arepeat%7D%0A._4Cj9aGA17z%7Bbackground-position-x%3A-1px%7D%0A._21ytgeA17z%7Bbackground-position-y%3A-1px%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._4kiQYACr5D%7Bmin-height%3Acalc(100vh%20-%2056px)%7D%0A._0jFU0VE6Kk%7Bheight%3A-moz-fit-content%3Bheight%3Afit-content%7D%0A._4ouGXIgZxp%7Bmin-width%3A200px%7D");
















import React, { ComponentType } from 'react';
import ExitingPersistence from '@atlaskit/motion/exiting-persistence';
import { Main } from '@atlaskit/navigation-system/layout/main';
import { useGlobalObjectPreviewPanels, usePreviewPanelIFrameCommunication } from '@atlassian/preview-panel-global-objects/global-object-preview-panels';
// eslint-disable-line @typescript-eslint/no-unused-vars

import { useRovoWorkspace } from '@townsquare/collab-context';
import { useIsForYouRefreshed } from '@townsquare/for-you-refresh';
import { GriffinMainGrid } from '@townsquare/griffin-main-grid';
import { GriffinMainGridContent } from '@townsquare/griffin-main-grid/content';
import { GriffinMainGridHeader } from '@townsquare/griffin-main-grid/header';
import { CustomWidthPreviewPanelContainer } from '@townsquare/preview-panels/customWidthPreviewPanelContainer';
import { AggRelayEnvironmentProvider } from '@townsquare/relay-utils/agg-environment';
import { RouteComponent } from '@townsquare/router/RouteComponent';
import { HomepageRoute, LayoutType } from '@townsquare/router/route-types';
import { useRouter } from '@townsquare/router/useRouter';
import { searchRoute } from '@townsquare/routes/search';
import { goalsAppGlobalSearchRoute } from '@townsquare/routes/search-goals-app';
import { projectsAppGlobalSearchRoute } from '@townsquare/routes/search-projects-app';
import { teamsAppGlobalSearchRoute } from '@townsquare/routes/search-teams-app';
import { sharedConversationPreviewRoute } from '@townsquare/routes/shared-conversation-preview';
import { RovoButton } from '@townsquare/rovo-ai-button';
import { useRightSidebarState } from '@townsquare/sidebar-panel/right-sidebar';
import { isEntryPointPanelSupported } from '@townsquare/sidebar-panel/utils';
import { LegacySidebarPanel } from '@townsquare/sidebar-panel-utils/legacy-sidebar-panel';
import { fg } from '@townsquare/stat-sig/gate';
import { useIsOnFullPageRovoChat } from '../utils/route-utils';
import { GriffinResponsiveAside } from './GriffinResponsiveAside';

// Expected with for main column CONTENT is 1232px.
const MAIN_CONTENT_LX_WIDTH = '1232px';
const FPS_CONTAINED_ROUTE_NAMES: readonly string[] = [searchRoute.name, goalsAppGlobalSearchRoute.name, projectsAppGlobalSearchRoute.name, teamsAppGlobalSearchRoute.name];
type AsideType = Exclude<HomepageRoute['aside'], undefined>;
type GriffinLayoutProps = {
  aside: AsideType | undefined;
  layout: LayoutType;
  isScrollContained?: boolean;
  includeGridBackground?: boolean;
};
const gridLineColor = `#88888f0d`;
const compiledDefaultMainContentStyles = {
  root: "_3SamIHVa5s _2Y7lL45zaO _1mT5xdRAKS _2xTnZxIZbP _0GTcwRIZbP _24h04iPvdi _1EqgXlprl1 _1DVCh3Va5s"
};
const compiledGridStyles = {
  root: "_3CkH9o19eh _3OqcjTkyAR _2z4m57XEN5 _4Cj9aGA17z _21ytgeA17z _24h04i2Njc _4kiQYACr5D _0jFU0VE6Kk _4ouGXIgZxp"
};
const compiledRefreshedWidthCapStyles = {
  root: "_1EqgXl0Qmj"
};
const compiledMainContentWithAsideStyles = {
  root: "_1EqgXlOAqP"
};
const GriffinMainContent = (props: GriffinLayoutProps) => {
  const useDefaultStyle = props.layout === 'home';
  const isForYouRefreshed = useIsForYouRefreshed();
  const page = <GriffinMainGridContent isScrollContained={props.isScrollContained}>
			{useDefaultStyle ? <div className={ax([compiledDefaultMainContentStyles.root, props.aside && "", useDefaultStyle && isForYouRefreshed && props.includeGridBackground && ""])}>
					<RouteComponent />
				</div> : <RouteComponent />}
		</GriffinMainGridContent>;
  if (isForYouRefreshed && props.includeGridBackground) {
    return <div className={ax([compiledGridStyles.root])}>{page}</div>;
  }
  return page;
};
const GriffinWithAside = (props: GriffinLayoutProps & {
  aside: AsideType;
  hasNewHeader: boolean;
}) => {
  const AsideComponent = props.aside;
  return <>
			<GriffinMainContent {...props} />
			<GriffinResponsiveAside hasNewHeader={props.hasNewHeader}>
				<AsideComponent />
			</GriffinResponsiveAside>
		</>;
};
const AggRelayProvider = ({
  children
}: {
  children: React.ReactNode;
}) => <AggRelayEnvironmentProvider>{children}</AggRelayEnvironmentProvider>;
export const GriffinLayout = ({
  PlatformSidebarPanel
}: {
  PlatformSidebarPanel: ComponentType;
}): React.JSX.Element => {
  const {
    currentPanel
  } = useRightSidebarState();
  const [routerState] = useRouter();
  const cloudId = useRovoWorkspace();
  const {
    openPreviewPanel
  } = useGlobalObjectPreviewPanels('home', cloudId ?? '');
  usePreviewPanelIFrameCommunication(openPreviewPanel);
  const isForYouRefreshed = useIsForYouRefreshed();
  const route = (routerState.route as HomepageRoute);
  const layout = route.nav4Layout ?? (route?.layout || 'home');
  const HeaderComponent = route.header;
  const AggContainer = route.aggContainer;
  const isOnFullPageRovoChat = useIsOnFullPageRovoChat();
  const isScrollContained = isOnFullPageRovoChat || fg('rovo_fps_fill_container') && FPS_CONTAINED_ROUTE_NAMES.includes(routerState.route.name);
  const shouldShowRovoButton = (routeName: string) => {
    if (routeName === 'hometab') {
      // must not be on home tab page to show the button
      return false;
    }
    if (routeName === sharedConversationPreviewRoute.name) {
      return false;
    }
    return !isOnFullPageRovoChat;
  };
  const showRovoButton = shouldShowRovoButton(routerState.route.name);
  const shouldShowSidebarPanel = currentPanel && isEntryPointPanelSupported(currentPanel);
  const includeGridBackground = isForYouRefreshed && routerState.route.name === 'hometab';
  const content = route.aside ? <GriffinWithAside layout={layout} aside={route?.aside} hasNewHeader={!!route.header} isScrollContained={isScrollContained} includeGridBackground={includeGridBackground} /> : <GriffinMainContent layout={layout} aside={route?.aside} isScrollContained={isScrollContained} includeGridBackground={includeGridBackground} />;
  const shouldShowEntryPointSidebarPanel = !isOnFullPageRovoChat && shouldShowSidebarPanel;
  const entryPointSidebarPanel = shouldShowEntryPointSidebarPanel ? <PlatformSidebarPanel key="entry-point-sidebar-panel" /> : null;

  // `ExitingPersistence` has to sit outside the conditional so the panel it is holding onto
  // survives `shouldShowEntryPointSidebarPanel` flipping to false and can play its exit motion.
  const SidebarPanel = <>
			{fg('platform-dst-motion-uplift-panel') ? <ExitingPersistence>{entryPointSidebarPanel}</ExitingPersistence> : entryPointSidebarPanel}
			{!isOnFullPageRovoChat && !shouldShowSidebarPanel && <LegacySidebarPanel currentPanel={currentPanel} />}
		</>;
  const RelayProvider = route.relayEnvironment === 'agg' ? AggRelayProvider : React.Fragment;
  if (layout === 'custom') {
    return <RelayProvider>
				<Main testId={routerState.route.name}>
					<RouteComponent />
					{showRovoButton && <RovoButton />}
				</Main>
				{SidebarPanel}
				<CustomWidthPreviewPanelContainer />
			</RelayProvider>;
  }
  const LayoutContent = <RelayProvider>
			<Main testId={routerState.route.name}>
				<GriffinMainGrid isSinglePaneScrollContainer={isScrollContained}>
					{HeaderComponent && <GriffinMainGridHeader>
							<HeaderComponent />
						</GriffinMainGridHeader>}
					{content}
					{showRovoButton && <RovoButton />}
				</GriffinMainGrid>
			</Main>
			{SidebarPanel}
			<CustomWidthPreviewPanelContainer />
		</RelayProvider>;
  if (fg('townsquare_enable_combined_agg_query_sidebar') && AggContainer) {
    return <AggContainer>{LayoutContent}</AggContainer>;
  }
  return LayoutContent;
};